<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3jrbcJ/tc-custom/9780802195005.jpg?1726617394474" alt="This image is the cover for the book Free Man of Color"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Free Man of Color
      </h1>
      <p class="bookDescription body article font2">
        <b>The Tony Award-winning playwright spins “a tale of adultery, racism and the Louisiana Purchase…with daring and dizzying skill” (Ben Brantley, <i>The New York Times</i>).</b><br/><br/>The author of classics American plays such as <i>Six Degrees of Separation</i> and <i>The House of Blue Leaves</i>, Tony and Obie Award-winning playwright John Guare is celebrated for his theatrically playful, intellectually dazzling imagination. His play “<i>A Free Man of Color</i> evolves from a bustling farce into something deeper and darker but similarly exhilarating” (<i>USA Today</i>).<br/><br/><i>A Free Man of Color</i> is set in boisterous New Orleans prior to the historic Louisiana Purchase. Before law and order took hold and class, racial, and political lines were drawn, New Orleans was a carnival of beautiful women, flowing wine, and pleasure for the taking. At the center of this Dionysian world is Jacques Cornet, a mixed-race gentleman who commands men, seduces women, and preens like a peacock. But it is 1801 and the map of New Orleans is about to be redrawn. The Louisiana Purchase brings American rule and racial segregation to the chaotic, colorful world of Jacques Cornet and all that he represents, turning the tables on freedom and liberty.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Guare
      </h2>
      
      <p class="authorDescription body article">John Guare is the Tony, Obie, and New York Drama Critics Circle Award-winning playwright of the plays House of Blue Leaves, Six Degrees of Separation, Landscape of the Body, and A Few Stout Individuals. He co-edits the Lincoln Center Theater Review, teaches playwriting at Yale School of Drama, is a council member of the Dramatists Guild, a trustee of PEN America and received the Gold Medal in Drama from the American Academy of Arts and Letters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dd6496be